import { Input, Select, SelectItem } from '@heroui/react'
import { Trash2 } from 'lucide-react'
import { Button as HeroButton } from '@heroui/react'
import type { RuleAction, ActionType } from '../../types'
import { ACTION_TYPE_LABELS } from '../../types'

interface ActionEditorProps {
  action: RuleAction
  onChange: (updates: Partial<RuleAction>) => void
  onDelete: () => void
}

const ACTION_TARGET_LABELS: Record<ActionType, string> = {
  show_step: 'Step ID',
  skip_step: 'Step ID',
  redirect: 'URL',
  apply_discount: 'Discount Code',
  set_variant: 'Variant ID',
  log_event: 'Event Name',
}

export function ActionEditor({ action, onChange, onDelete }: ActionEditorProps) {
  return (
    <div
      className="flex items-start gap-2 p-2 rounded-lg border border-fn-border bg-fn-muted"
    >
      <div className="flex-1 grid grid-cols-2 gap-2">
        <Select
          size="sm"
          variant="bordered"
          selectedKeys={[action.type]}
          onSelectionChange={(keys) => {
            const type = Array.from(keys)[0] as ActionType
            if (type) onChange({ type, target: '' })
          }}
          aria-label="Action type"
        >
          {Object.entries(ACTION_TYPE_LABELS).map(([key, label]) => (
            <SelectItem key={key}>{label}</SelectItem>
          ))}
        </Select>

        <Input
          size="sm"
          variant="bordered"
          placeholder={ACTION_TARGET_LABELS[action.type] || 'Target'}
          value={action.target || ''}
          onValueChange={(val) => onChange({ target: val })}
          aria-label="Target"
        />
      </div>

      <HeroButton
        isIconOnly
        size="sm"
        variant="light"
        color="danger"
        onPress={onDelete}
        aria-label="Delete action"
      >
        <Trash2 className="w-3.5 h-3.5" />
      </HeroButton>
    </div>
  )
}
